/* Albeux High-End Draft 4 — zoom on every collection image (behaviour)
   1. Product cards rise and zoom in once as they scroll into view (.is-in).
   2. Every collection tile and product card gets .is-zin while it is on screen, which starts the slow zoom-in
      in albeux-grid.css. It is removed when the tile leaves the screen, so the zoom plays again on the way back.
   Smoothness pass (31 Oct 2026): the page watcher now only wakes up when new tiles or cards are actually added,
   not for every little change (the sweep panels of the collection effect used to wake it up on every picture). */
(function () {
  if (window.__albeuxGrid) return;
  window.__albeuxGrid = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  document.documentElement.classList.add('albeux-grid-js');

  var ENTER = '.product-grid__item';
  var ZOOM = '.albeux-coll__card, .albeux-feature__tile, .collection-card, .product-grid__item, .resource-list__item';

  var enterIO = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            enterIO.unobserve(e.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px 8% 0px' })
    : null;

  var zoomIO = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) e.target.classList.add('is-zin');
          else e.target.classList.remove('is-zin');
        });
      }, { threshold: 0.3 })
    : null;

  function tag() {
    document.querySelectorAll(ENTER + ':not([data-agz])').forEach(function (li) {
      li.setAttribute('data-agz', '1');
      if (enterIO) enterIO.observe(li); else li.classList.add('is-in');
    });
    document.querySelectorAll(ZOOM + ':not([data-azoom])').forEach(function (el) {
      el.setAttribute('data-azoom', '1');
      if (zoomIO) zoomIO.observe(el); else el.classList.add('is-zin');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tag); else tag();
  document.addEventListener('shopify:section:load', tag);

  /* Only the arrival of a tile or card matters: filters, sorting and infinite scroll bring new ones in */
  var TILE = '.albeux-coll__card, .albeux-feature__tile, .collection-card, .product-grid__item, .resource-list__item';
  function hasNewTiles(muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if ((n.matches && n.matches(TILE)) || (n.querySelector && n.querySelector(TILE))) return true;
      }
    }
    return false;
  }

  var main = document.getElementById('MainContent');
  var queued = false;
  if (main && 'MutationObserver' in window) {
    new MutationObserver(function (muts) {
      if (queued || !hasNewTiles(muts)) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; tag(); });
    }).observe(main, { childList: true, subtree: true });
  }

  /* Safety net: a card near the screen is never left hidden */
  setTimeout(function () {
    document.querySelectorAll(ENTER + ':not(.is-in)').forEach(function (li) {
      var r = li.getBoundingClientRect();
      if (r.top < window.innerHeight * 1.2 && r.bottom > 0) li.classList.add('is-in');
    });
  }, 1500);
})();